import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  addWallOfFameAsync,
  getAllWallOfFameAsync,
  getWallOfFameByIdAsync,
  updateWallOfByIdAsync,
  deleteWallOfFameAsync,
  uploadWallOfFameExcelAsync,
  getAllBulkFilesWallOfFame,
} from "./wallofframe.async";

const initialState = {
  wallofFameLoader: false,
  addWallOfFame: [],
  allWallOfFame: [],
  getWallOfFameById: [],
  updateWallOfFameById: [],
  deleteWallOfFame: [],
  bulkWallOfFame: [],
  bulkFilesWallOfFame: [],
};

export const wallofframeSlice = createSlice({
  name: "language",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        addWallOfFameAsync.pending,
        getAllWallOfFameAsync.pending,
        getWallOfFameByIdAsync.pending,
        updateWallOfByIdAsync.pending,
        deleteWallOfFameAsync.pending,
        uploadWallOfFameExcelAsync.pending,
        getAllBulkFilesWallOfFame.pending
      ),
      (state) => {
        state.wallofFameLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllBulkFilesWallOfFame.fulfilled),
      (state, action) => {
        state.wallofFameLoader = false;
        state.bulkFilesWallOfFame = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(uploadWallOfFameExcelAsync.fulfilled),
      (state, action) => {
        state.wallofFameLoader = false;
        state.bulkWallOfFame = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(addWallOfFameAsync.fulfilled),
      (state, action) => {
        state.wallofFameLoader = false;
        state.addWallOfFame = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllWallOfFameAsync.fulfilled),
      (state, action) => {
        state.wallofFameLoader = false;
        state.allWallOfFame = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(getWallOfFameByIdAsync.fulfilled),
      (state, action) => {
        state.wallofFameLoader = false;
        state.getWallOfFameById = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(updateWallOfByIdAsync.fulfilled),
      (state, action) => {
        state.wallofFameLoader = false;
        state.updateWallOfFameById = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(deleteWallOfFameAsync.fulfilled),
      (state, action) => {
        state.wallofFameLoader = false;
        state.deleteWallOfFame = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(
        addWallOfFameAsync.rejected,
        getAllWallOfFameAsync.rejected,
        getWallOfFameByIdAsync.rejected,
        updateWallOfByIdAsync.rejected,
        deleteWallOfFameAsync.rejected,
        uploadWallOfFameExcelAsync.rejected,
        getAllBulkFilesWallOfFame.rejected
      ),
      (state, action) => {
        state.wallofFameLoader = false;
      }
    );
  },

  reducers: {
    emptyWallOfFame: () => initialState,
    resetWallOfFameLoader: (state) => {
      state.wallofFameLoader = false;
    },
  },
});

export const { emptyWallOfFame, resetWallOfFameLoader } =
  wallofframeSlice.actions;

export default wallofframeSlice.reducer;
